// removed by extract-text-webpack-plugin
module.exports = {"container":"_1RYb8cq59YaXyEnSC4Ghe0","row":"K9qrScohSDRkNv5ETVQxz","table":"_1qeQ21uH5zx4PhrrEujP2W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisBuyOrders.scss
// module id = 1202
// module chunks = 0